import { companies } from '../data/companies';
import { faqs } from '../data/faqs';
import { author, canonicalUrl, site } from '../data/site';

const personId = `${canonicalUrl}#author`;

export function buildStructuredData() {
  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': personId,
    name: author.name,
    jobTitle: author.role,
    description: author.bio,
    sameAs: [author.linkedin],
  };

  const article = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: site.title,
    description: site.description,
    image: [site.ogImage],
    datePublished: site.published,
    dateModified: site.modified,
    inLanguage: 'en-GB',
    mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
    author: { '@type': 'Person', '@id': personId, name: author.name, url: author.linkedin },
    publisher: { '@type': 'Organization', name: site.name, url: site.url },
    about: 'AI workflow automation services in England',
  };

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: site.title,
    itemListOrder: 'https://schema.org/ItemListOrderAscending',
    numberOfItems: companies.length,
    itemListElement: companies.map((company) => ({
      '@type': 'ListItem',
      position: company.rank,
      name: company.name,
      url: company.url,
    })),
  };

  return [article, person, faqPage, itemList];
}
